module.exports = __webpack_public_path__ + "static/media/intro-image-2.50bac78e.jpg";